import React, { useState } from 'react';
import { Row, Col, Typography, Flex, Icons } from '@jcm/design-system';
import { EnumNovidade } from '../../../ts/enums/NovidadesEnum';
import { formatarDataPtBr } from '../../../utils/datas/formatarDataPtBr';
import estilos from './index.module.scss';
import { TNovidadeLocalStorage } from '../../../ts/types/Novidade';
import { useGovernancaContext } from '../../../../../../context/GovernancaContext';
import { iconeNotificacao } from '../RecuperarIconeNotificacao/recuperarIconeNotificacao';

interface PropsNotificacao {
	tipo: EnumNovidade;
	titulo: string;
	descricao: string;
	dataInserida: string;
	novidadeId: number;
}

const CartaoNotificacao: React.FC<PropsNotificacao> = ({ tipo, descricao, dataInserida, novidadeId }) => {
	const { setNotificacoes } = useGovernancaContext();
	const [visivel, setVisivel] = useState(true);
	const [saindo, setSaindo] = useState(false);

	const fecharCartao = (novidadeId: number) => {
		setSaindo(true);
	
		const notificacoesSalvas: TNovidadeLocalStorage[] = JSON.parse(
			localStorage.getItem('notificacao') ?? '[]'
		);
	
		const notificacoesAtualizadas = notificacoesSalvas.map((notificacao) =>
			notificacao.novidadeId === novidadeId ? { ...notificacao, visualizado: true } : notificacao
		);
	
		const listaSemDuplicatas = notificacoesAtualizadas.filter(
			(notificacaoAtual, index, listaCompleta) => {
				const primeiroIndice = listaCompleta.findIndex(
					(notificacaoNaLista) => notificacaoNaLista.novidadeId === notificacaoAtual.novidadeId
				);
				
				return primeiroIndice === index;
			}
		);
		
	
		localStorage.setItem('notificacao', JSON.stringify(listaSemDuplicatas));
	
		const notificacoesNaoVisualizadas = listaSemDuplicatas.filter(
			(notificacao) => !notificacao.visualizado
		);
	
		setNotificacoes(notificacoesNaoVisualizadas);
	
		setTimeout(() => {
			setVisivel(false);
		}, 300);
	};
	

	if (!visivel) return null;

	return (
		<Row className={`${estilos.notificationExit} ${saindo ? estilos.notificationExitActive : ''}`}>
			<Col span={22}>
				<Row gutter={[40, 10]}>
					<Col span={24}>
						<Flex gap={10} align='center'>
							{iconeNotificacao(tipo)}
						</Flex>
					</Col>
					<Col span={22} className={estilos.descricaoNovidade}>
						<Typography.Body>{descricao}</Typography.Body>
					</Col>
					<Col>
						<Typography.Body className={estilos.data}>{formatarDataPtBr(dataInserida)}</Typography.Body>
					</Col>
				</Row>
			</Col>
			<Col span={2}>
				<Flex align='center'>
					<Icons.Close
						className={estilos.iconeFechar}
						onClick={() => {
							fecharCartao(novidadeId);
						}}
					/>
				</Flex>
			</Col>
		</Row>
	);
};

export default CartaoNotificacao;
